import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { ref: "suggestDOM" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggests, (text, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["suggest-item", {'selected-item': _ctx.adjustSelected(index)}]),
          ref_for: true,
          ref: `${index}`,
          key: `item-${index}`
        }, _toDisplayString(text), 3))
      }), 128)),
      (!_ctx.suggests.length)
        ? (_openBlock(), _createElementBlock("i", _hoisted_2, "没有匹配结果"))
        : _createCommentVNode("", true)
    ], 512)
  ]))
}